import {
  GET_ASSETS,
  GET_ASSETS_REFERENCES
} from './mutationTypes';

import { setActionStatusError, setActionStatusSuccess, setActionStatusPending } from '@/store/helpers';


export default {
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError,
  [GET_ASSETS](state, assetsList) {
    state.assetsList = assetsList;
  },
  [GET_ASSETS_REFERENCES](state, assetReferencesList) {
    state.assetReferences = assetReferencesList;
  },
};